import { render, staticRenderFns } from "./goods-range.vue?vue&type=template&id=3b852c52&scoped=true&"
import script from "./goods-range.vue?vue&type=script&lang=js&"
export * from "./goods-range.vue?vue&type=script&lang=js&"
import style0 from "./goods-range.vue?vue&type=style&index=0&id=3b852c52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b852c52",
  null
  
)

export default component.exports